import styled from "styled-components";

export const UiErrorFallback = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	min-height: 320px;
	padding: 24px;
	text-align: center;

	> h2 {
		margin-bottom: 8px;
		font-size: 20px;
		font-weight: 500;
	}

	> p {
		margin-bottom: 24px;
		color: rgba(0, 0, 0, 0.45);
	}
`;

export const UiReloadButton = styled.button`
	padding: 8px 24px;
	color: #fff;
	font-size: 14px;
	background-color: #ec7963;
	border: 0;
	border-radius: 4px;
	cursor: pointer;

	&:hover {
		opacity: 0.85;
	}
`;
